import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiListSubheader from "@material-ui/core/ListSubheader";
import classNames from "classnames";
import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "inherit",
    userSelect: "none",
    fontSize: theme.typography.caption.fontSize
  },
  header: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.caption.fontSize,
    padding: theme.spacing(0, 4),
    textTransform: "uppercase"
  },
  subheader: {
    color: theme.palette.text.secondary,
    ...theme.typography.caption,
    padding: theme.spacing(0, 4),
    lineHeight: theme.typography.body1.lineHeight
  }
}));
export const ListSubheader = props => {
  const {
    className,
    isSideNav,
    ...otherProps
  } = props;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiListSubheader, _extends({}, otherProps, {
    className: classNames("prmbl-listSubheader", className, classes.root, {
      [classes.header]: isSideNav === "header"
    }, {
      [classes.subheader]: isSideNav === "subheader"
    })
  }));
};
export default ListSubheader;